import React from 'react';

const TableRow = ({el, order, handleValidation}) => {

    return (
        <tr>
            <th scope="row">{++order}</th>
            <td>{el.nombre + " " + el.apellido1 + " " + el.apellido2}</td>
            <td>{el.institucion_educativa}</td>
            <td>{el.titulo}</td>
            <td>{el.correo_electronico}</td>
            <td>{el.telefono}</td>
            <td>{el.fecha_registro}</td>
            <td>
                <button className="p-button p-component p-button-rounded p-button-warning" onClick={() => handleValidation(el.solicitudid, el.statusid)}>
                    <span className="p-button-label p-c">{el.status}</span><span className="p-ink"></span>
                </button>

                {/* {(el.statusid === 9 || el.statusid === 5 ? 
                    <button className="p-button p-component p-button-rounded p-button-warning" onClick={() => handleValidation(el.solicitudid, el.statusid)}>
                        <span className="p-button-label p-c">{el.status}</span><span className="p-ink"></span>
                    </button>
                    : 
                    (el.statusid === 7 ? 
                        <button className="p-button p-component p-button-rounded p-button-success" onClick={() => handleValidation(el.solicitudid, el.statusid)}>
                            <span className="p-button-label p-c">Cerrar</span><span className="p-ink"></span>
                        </button>
                        :
                        ''
                    ))} */}
            </td>
        </tr>
    );  
}

export default TableRow;